// Import base components
import http, { httpV2 } from "../http.js";

export const getEmailAccounts = async () => httpV2.get("/email");
export const getAuthUrl = async (account_name, account_email) =>
  httpV2.post("/email/auth", { account_name, account_email });

export const disconnectEmailAccount = async (id) =>
  httpV2.delete(`/email/${id}`);
